import _asyncToGenerator from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/builds/assist/zerobounce-website/node_modules/@babel/runtime/regenerator/index.js";
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { parseIdxResponse } from './idxResponseParser.js';
function makeIdxState(authClient, idxResponse, toPersist, requestDidSucceed) {
  var _a, _b, _c;
  var rawIdxResponse = idxResponse;
  var _parseIdxResponse = parseIdxResponse(authClient, idxResponse, toPersist),
    remediations = _parseIdxResponse.remediations,
    context = _parseIdxResponse.context,
    actions = _parseIdxResponse.actions;
  var neededToProceed = _toConsumableArray(remediations);
  var proceed = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(remediationChoice) {
      var paramsFromUser,
        remediationChoiceObject,
        actionFn,
        _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            paramsFromUser = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            remediationChoiceObject = remediations.find(function (remediation) {
              return remediation.name === remediationChoice;
            });
            if (remediationChoiceObject) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return", Promise.reject("Unknown remediation choice: [".concat(remediationChoice, "]")));
          case 4:
            actionFn = remediationChoiceObject.action;
            if (!(typeof actionFn !== 'function')) {
              _context.next = 7;
              break;
            }
            return _context.abrupt("return", Promise.reject("Current remediation cannot make form submit action: [".concat(remediationChoice, "]")));
          case 7:
            return _context.abrupt("return", remediationChoiceObject.action(paramsFromUser));
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function proceed(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var findCode = function findCode(item) {
    return item.name === 'interaction_code';
  };
  var interactionCode = (_c = (_b = (_a = rawIdxResponse.successWithInteractionCode) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.find(findCode)) === null || _c === void 0 ? void 0 : _c.value;
  return {
    proceed: proceed,
    neededToProceed: neededToProceed,
    actions: actions,
    context: context,
    rawIdxState: rawIdxResponse,
    interactionCode: interactionCode,
    toPersist: toPersist,
    requestDidSucceed: requestDidSucceed
  };
}
export { makeIdxState };